module.exports = __webpack_public_path__ + "img/banner.89224548.png";